import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import { SerialConfirmOpenSlotsScreen } from '../confirm-open-slots-shared/serial-confirm-open-slots-screen.component';
import usePickUpConfirmOpenSlotsSerial from './pick-up-confirm-open-slots-serial.controller';

const ID = 'pick-up-confirm-open-slots-serial';

const PickUpConfirmOpenSlotsSerial = () => {
    const viewProps = usePickUpConfirmOpenSlotsSerial();

    return (
        <SerialConfirmOpenSlotsScreen
            id={ID}
            headerTitle={CommonMessage.BUTTONS.PICK_UP}
            viewProps={viewProps}
            openSlotLabel={
                <FormattedMessage
                    id='kiosk.wizard.pick-up-confirm-open-slots-serial.open-slot'
                    defaultMessage='Open SLOT'
                    description='Button to open the current pick-up SLOT in the serial colli loop'
                />
            }
        />
    );
};

export default PickUpConfirmOpenSlotsSerial;
